module.exports = __webpack_public_path__ + "img/sc-bg.d7d2c870.png";